/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup';
import { DESTINATION_TYPES } from '../../../containers/destination/constants/destinationTypes';
import { validateDataType } from './dataTypeValidator';

const validateSourceType = (sourceType, currentValue, allowedDataTypes) =>
  !!validateDataType(sourceType, currentValue, allowedDataTypes);
export const validationSchema = (
  destinationType,
  tableNameLimit,
  destinationTableNames = [],
  withMappingData = false
) => {
  const isFireboltDest = destinationType === DESTINATION_TYPES.FIREBOLT.name;

  let validation = Yup.object({
    tableName: Yup.string()
      .max(tableNameLimit)
      .test(
        'report-test-unique',
        'A Table with name ${value} already exists in the destination.',
        value => destinationTableNames.indexOf(value) === -1
      )
      .required(),
    fields: Yup.array()
      .min(1)
      .of(
        Yup.object({
          destination: Yup.object()
            .shape({
              name: Yup.string().trim().required()
            })
            .required(),
          dataType: Yup.object().required()
        }).test('mapping-test-with-required-datatype', '', value => {
          const field = value as any;
          if (!withMappingData) {
            return true;
          }

          return validateSourceType(
            field?.source?.type?.type_display,
            field.dataType,
            field?.allowed_dest_types
          );
        })
      )

      .required()
  });

  if (isFireboltDest) {
    validation = validation.shape({
      fireboltTableType: Yup.object().required()
    });
  }

  return validation;
};
